import { render } from "./Footer.vue?vue&type=template&id=31a29cfa&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=31a29cfa&scoped=true&lang=css"

import exportComponent from "/Users/nceba/Documents/code/apps/twist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a29cfa"]])

export default __exports__